import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

function FormTooltip({ tooltip }: { tooltip: string }) {
    const onClickHandler = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
    };

    const popover = (
        <Popover id="po" className="tt">
            <Popover.Content>
                <div dangerouslySetInnerHTML={{ __html: tooltip }} />
            </Popover.Content>
        </Popover>
    );

    return (
        <div className="d-inline formTooltip">
            <OverlayTrigger key="top" placement="top" trigger="click" overlay={popover} rootClose>
                <div className="icon" onClick={onClickHandler} />
            </OverlayTrigger>
        </div>
    );
}

export default FormTooltip;
